import React from 'react';
import PropTypes from 'prop-types';
import { useField, useFormikContext } from 'formik';

import RadioButtonGroup from 'components/radio-button-group';

import './style.css';

const FieldRadioButtonGroup = ({ className, ...rest }) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(rest);
  return (
    <RadioButtonGroup
      {...rest}
      className={className}
      onChange={(value) => setFieldValue(field.name, value)}
    />
  );
};

FieldRadioButtonGroup.propTypes = {
  className: PropTypes.string,
};

FieldRadioButtonGroup.defaultProps = {
  className: null,
};

export default FieldRadioButtonGroup;
